(function () {
    "use strict";

    angular.module("app.search").controller("SearchController", SearchController);

    SearchController.$inject = ["$scope", "$cookies", "SearchService"];

    function SearchController($scope, $cookies, SearchService) {
        /* jshint validthis:true */
        var vm = this;
        vm.searchKey = null;
        vm.mouseleaved = true;

        function activate() {
            vm.searchHistory = ($cookies.get("searchHistory") || "").split(",").filter(function (item) {
                return item != "";
            });
            SearchService.getLastViewProducts().then(function (response) {
                HidePriceData(response);
                vm.lastViewProducts = response;
            });
        }

        function HidePriceData(SearchProductsResponse){
            if(SearchProductsResponse){
                if(SearchProductsResponse.Data){
                SearchProductsResponse.Data.forEach(element => {
                    if(element.HidePrice === true){
                        element.Price = undefined;
                        element.PriceWithDiscount = undefined;
                        }

                    });                    
                }
            }
        }

        $scope.$watch("vm.searchKey", function (value) {
            if (value) {
                vm.addSearchHistory(value);
                SearchService.searchProduct(value,vm.cultures).then(function (response) {
                    HidePriceData(response);
                    vm.searchProductResult = response;
                });

                SearchService.searchCategory(value, vm.cultures).then(function (response) {
                    vm.searchCategoryResult = response;
                });

                SearchService.searchSalesPoint(value, vm.cultures).then(function (response) {
                    vm.searchSalesPointResult = response;
                });
            }
        });

        vm.addSearchHistory = function (value) {
            var searckKey = vm.searchHistory.find(function (item) {
                return item == value;
            });
            if (!searckKey) {
                vm.searchHistory.push(value);
                vm.searchHistory = vm.searchHistory.reverse().slice(0, 5);
                $cookies.put("searchHistory", vm.searchHistory);
            }
        };

        vm.clearLastViewProduct = function () {
            $cookies.remove("LastViewProduct");
            vm.lastViewProducts = {};
        };

        vm.focus = function (templateId) {
            vm.focused = true;
            vm.mouseleaved = false;
            vm.showSearchResult = true;
            $(".arama .input-group").addClass("search-focused");
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                $("#" + templateId + " .arama").addClass("mobile-search-active");
            }
        };

        vm.blurSearch = function (templateId) {
            vm.focused = false;
            if (!vm.focused && vm.mouseleaved) {
                vm.clear(templateId);
            }
        };

        vm.mouseleaveSearch = function (templateId) {
            vm.mouseleaved = true;
            if (!vm.focused && vm.mouseleaved) {
                vm.clear(templateId);
            }
        };

        vm.clear = function (templateId) {
            vm.showSearchResult = false;
            vm.focused = false;
            vm.mouseleaved = true;
            vm.searchProductResult = null;
            vm.searchCategoryResult = null;
            vm.searchKey = null;
            $(".arama .input-group").removeClass("search-focused");
            $("#" + templateId + " .arama").removeClass("mobile-search-active");
        };

        vm.clearSearchHistory = function () {
            $cookies.remove("searchHistory");
            vm.searchHistory = [];
        };

        vm.setSearch = function (history) {
            vm.searchKey = history;
        };

        activate();
    }
})();
